/**
 * @deprecated
 */
export enum DisplayMode {
  Modal = 'modal',
  FullPage = 'fullPage',
}
/**
 * @deprecated
 */
export enum ViewMenuTypes {
  IconOptions = 'iconOptions',
  SelectOptions = 'selectOptions',
  ButtonOptions = 'buttonOptions',
  SwitchOptions = 'switch'
}
/**
 * @deprecated
 */
export enum ViewMode {
  ViewModeKey = 'viewMode',
  Grid = 'grid',
  List = 'list',
}

/**
 * @deprecated
 */
export type ViewMenuOptions = {
  menuType: string
    menuLabel: string
    menuName: string
    options: {value: string, label: string}[]
}
